'use client';

import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTargetId } from '../../../store/projectStore';

const SIGNAL_LIST_QUERY_NAME = 'endpoint-signals-paginated';
const SIGNAL_COUNT_QUERY_NAMES = [
  'signal-counts',
  'ai-component-signal-counts',
] as const;

export function useSignalsQueryInvalidation() {
  const targetId = useTargetId();
  const queryClient = useQueryClient();
  const invalidateQueries = useCallback(
    (queryNames: readonly string[]) => {
      queryNames.forEach((queryName) => {
        void queryClient.invalidateQueries({
          queryKey: [queryName, targetId],
          exact: false,
        });
      });
    },
    [queryClient, targetId],
  );
  const invalidateSignalList = useCallback(
    () => invalidateQueries([SIGNAL_LIST_QUERY_NAME]),
    [invalidateQueries],
  );
  const invalidateSignalCounts = useCallback(
    () => invalidateQueries(SIGNAL_COUNT_QUERY_NAMES),
    [invalidateQueries],
  );

  return { invalidateSignalList, invalidateSignalCounts };
}
